import { format, isToday, isYesterday } from "date-fns";

export const formatCurrency = (
  value: number,
  opts: { currency?: string; noDecimal?: boolean } = {}
) => {
  const options = {
    currency: "GBP",
    noDecimal: true,
    ...opts,
  };

  return new Intl.NumberFormat(undefined, {
    style: "currency",
    currency: options.currency.toUpperCase(),
    minimumFractionDigits: options.noDecimal ? 0 : undefined,
  }).format(value);
};

export const formatDate = (value: string | Date) => {
  return format(new Date(value), "dd/MM/yyyy");
};

export const humanizeSalaryRange = (
  salaryMin: number,
  salaryMax: number,
  currency: string
) => {
  if (salaryMax == null) {
    return formatCurrency(salaryMin, { currency });
  }

  const min = formatCurrency(salaryMin, { currency });
  const max = formatCurrency(salaryMax, { currency });

  return `${min} - ${max}`;
};

export const humanizeTimeAgo = (value: string | Date) => {
  if (!value) {
    return "";
  }

  const date = new Date(value);

  if (isToday(date)) {
    return "today";
  }

  if (isYesterday(date)) {
    return "yesterday";
  }

  return new Intl.DateTimeFormat(navigator.language).format(date);
};


export const formatCurrencyWithSymbol = ({
  symbol = '',
  value = 0,
}: {
  symbol?: string;
  value?: number;
}): string => {
  const formattedAmount = new Intl.NumberFormat(undefined, {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  }).format(value);

  return `${symbol}${formattedAmount}`;
};


